import auth from "./auth";
import { createRouter, createWebHashHistory } from "vue-router";

import Home from "./views/home-page";
import Profile from "./views/profile-page";
import ManageUsers from "./views/manage-users";
import ManageBlueprints from "./views/manage-blueprints";
import ManageGroups from "./views/manage-groups";
import ManageSettings from "./views/manage-settings";
import ManageImports from "./views/manage-imports";
import PageLayout from "./views/page-layout";
import PageView from "./views/page-view";
import PageCreate from "./views/page-create";
import ItemDelete from "./views/item-delete";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

function loadView(view) {
	return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
	routes: [
		{
			path: "/home",
			name: "home",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: Home
		},
		{
			path: "/profile",
			name: "profile",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: Profile
		},
		{
			path: "/blueprints",
			name: "manage-blueprints",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageBlueprints
		},
		{
			path: "/users",
			name: "users",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageUsers
		},
		{
			path: "/groups",
			name: "manage-groups",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageGroups
		},
		{
			path: "/settings",
			name: "manage-settings",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageSettings
		},
		{
			path: "/imports",
			name: "manage-imports",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ManageImports
		},
		{
			path: "/layout/:groupRef([\\w-]+)/:pageRef([\\w-]+)",
			name: "page-layout",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: PageLayout
		},
		{
			path: "/delete/:itemType(\\w+)/:itemId(\\d+)",
			name: "delete-item",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: ItemDelete
		},
		{
			path: "/login-form",
			name: "login-form",
			meta: {
				requiresAuth: false,
				layout: simpleLayout,
				title: "Sign In"
			},
			component: loadView("login-form")
		},
		{
			path: "/reset-password",
			name: "reset-password",
			meta: {
				requiresAuth: false,
				layout: simpleLayout,
				title: "Reset Password",
				description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
			},
			component: loadView("reset-password-form")
		},
		{
			path: "/create-account",
			name: "create-account",
			meta: {
				requiresAuth: false,
				layout: simpleLayout,
				title: "Sign Up"
			},
			component: loadView("create-account-form"),
		},
		{
			path: "/change-password/:recoveryCode",
			name: "change-password",
			meta: {
				requiresAuth: false,
				layout: simpleLayout,
				title: "Change Password"
			},
			component: loadView("change-password-form")
		},
		{
			path: "/",
			redirect: "/home"
		},
		{
			path: "/recovery",
			redirect: "/home"
		},
		{
			path: "/:groupRef([\\w-]+)/_new",
			name: "new-page-in-group",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: PageCreate
		},
		{
			path: "/:groupRef([\\w-]+)/:pageRef([\\w-]+)/:contextId(\\d+)?",
			name: "page-view",
			meta: {
				requiresAuth: true,
				layout: defaultLayout
			},
			component: PageView
		},
		{
			path: "/:pathMatch(.*)*",
			redirect: "/home"
		}
	],
	history: createWebHashHistory()
});

router.beforeEach((to, from, next) => {

	if (to.name === "login-form" && auth.isLoggedIn()) {
		next({ name: "home" });
	}

	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!auth.isLoggedIn()) {
			next({
				name: "login-form",
				query: { redirect: to.fullPath }
			});
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;
